/* eslint-disable */
import React from 'react';

import './date-column.css';

import { DateField } from '../../../../../../../../../components';
import { useTranslate } from '../../../../../../../../../hooks';
import { baseDateFormatting } from '../../../../../../../../../common/helper';
import { Day } from '../../../../types';

type Props = {
  value: Day;
};

export function DateColumn({ value }: Props) {
  const { date = '', isToday = false } = value;

  const { translate } = useTranslate();

  return (
    <div className="date-cell">
      {isToday ? (
        <p className="font-today">{translate('Today')}</p>
      ) : (
        <DateField value={date} format={baseDateFormatting} />
      )}
    </div>
  );
}
